export enum OrderType {
  Glasses,
  ContactLenses
}